import { getSessionSignature } from 'src/app/services/ai-chat-auth-session';

const PERMISSIONS_URL = '/core/users/getCurrentUserPermissions/json';

let cachedGrants: { signature: string; granted: ReadonlySet<string> } | null = null;
let inflight: Promise<ReadonlySet<string>> | null = null;

/**
 * Коды PermissionItem, выданные текущему пользователю.
 * Источник — `/core/users/getCurrentUserPermissions/json`, не кэш AiChatUser.
 */
export async function loadGrantedPermissions(): Promise<ReadonlySet<string>> {
    const signature = getSessionSignature();

    if (cachedGrants && cachedGrants.signature === signature) {
        return cachedGrants.granted;
    }

    if (inflight) {
        return inflight;
    }

    inflight = (async () => {
        const response = await fetch(PERMISSIONS_URL, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
        });

        if (!response.ok) {
            throw new Error(`permissions http ${response.status}`);
        }

        const map = await response.json() as unknown;

        if (!map || typeof map !== 'object' || Array.isArray(map)) {
            throw new Error('permissions invalid payload');
        }

        const granted = new Set(
            Object.entries(map as Record<string, unknown>)
                .filter(([, allowed]) => allowed === true)
                .map(([code]) => code),
        );

        cachedGrants = { signature, granted };
        return granted;
    })().finally(() => {
        inflight = null;
    });

    return inflight;
}
